module.exports = __webpack_public_path__ + "static/media/14. Planery Session Datuk Dr. Anis Yusal Yusoff.74188bba.png";